import { FC } from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { getTheme } from 'Store/MultiDomain/MultiDomain.selector';
import { OverlayWrapper } from './styles';

interface IViewerLoadingOverlay {
  message: string;
}

const ViewerLoadingOverlay: FC<IViewerLoadingOverlay> = ({ message }) => {
  const theme = useSelector(getTheme);

  return (
    <OverlayWrapper>
      <Spin
        indicator={
          <LoadingOutlined
            style={{ fontSize: 32, color: theme.colors.primary.primary }}
            spin
          />
        }
      />
      <span>{message}</span>
    </OverlayWrapper>
  );
};

export default ViewerLoadingOverlay;
